
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as MaterialIconComponent } from "./material-icon.svg";

export const MaterialIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <MaterialIconComponent {...props} />;
};
